import util from '@utils/util';
/**
     * 个人页模块 组件
     * popupFans
     */
export default {
  name: 'popupFans',
  props: {
    fansList: Array,
    followAndFansNoMoreData: Boolean
  },
  methods: {
    clickClosePop: function clickClosePop() {
      this.$emit('clickClosePop', 'fansPop');
    },
    clickFollowFriend: function clickFollowFriend(uid, type, index) {
      this.$emit('clickFollowFriend', uid, type, index);
    },
    goPersonalLink: function goPersonalLink(uid) {
      if (!uid) {
        return 'javascript:;';
      }
      var local = util.getI18nLocale();
      // 带参传递
      var json = {
        pathname: "/".concat(local, "/u/").concat(uid, "/index.html")
      };
      return util.directToPath(json, true);
    }
  }
};